import React from 'react';
import { Card } from './ui/card';

/**
 * StatTile — single KPI card used on the youth dashboard overview.
 */
const StatTile = ({ label, value, icon, accent = 'blue', testId }) => {
  const ring = accent === 'amber'
    ? 'from-amber-300/60 to-amber-500/20'
    : 'from-blue-400/60 to-blue-700/20';
  return (
    <Card className="bs-glass border-0 p-5" data-testid={testId}>
      <div className="flex items-center justify-between mb-3">
        <p className="bs-muted text-xs font-semibold uppercase tracking-widest">{label}</p>
        <div className={`w-9 h-9 rounded-full bg-gradient-to-br ${ring} flex items-center justify-center text-white`}>
          {icon}
        </div>
      </div>
      <p className="bs-title text-3xl font-extrabold">{value}</p>
    </Card>
  );
};

export default StatTile;
